<script setup lang="ts">
import {ChevronDown} from "@lucide/vue";
import {nextTick, onMounted, ref} from "vue";
import MarkdownView from "@/core/components/markdown/Markdown.vue";

defineProps<{
    /** The advice seeded on the node (Markdown). */
    content: string
}>();

/** The advice text is long enough to overflow the modal, so it starts folded. */
const hook = ref<HTMLElement | null>(null);
const expanded = ref<boolean>(false);
const overflows = ref<boolean>(false);

onMounted(async () => {
    await nextTick();

    const element = hook.value;

    overflows.value = !!element && element.scrollHeight > element.clientHeight + 4;
});
</script>

<template>
  <div class="bg-pink-lighter rounded-md">
    <div
      ref="hook"
      class="relative overflow-hidden"
      :class="expanded ? 'max-h-none' : 'max-h-36'"
    >
      <MarkdownView :content="content" class="text-sm" />
      <div
        v-if="overflows && !expanded"
        class="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-lightPurple-lightest"
      />
    </div>
    <button
      v-if="overflows"
      type="button"
      class="flex w-full items-center justify-center gap-1 py-1 text-xs text-primary"
      :aria-expanded="expanded"
      @click="expanded = !expanded"
    >
      {{ expanded ? 'Réduire' : 'Voir la suite' }}
      <ChevronDown class="w-4" :class="{'rotate-180': expanded}" />
    </button>
  </div>
</template>
